import { User } from '@/modules/users/domain/user';

export const USER_EMPTY_STATE: User = {
    access_token: '',
    user: { id: -1, username: '', origin: '' },
    contact: {
        id: -1,
        status: -1,
        name: '',
        lastName: '',
        email: '',
        ci: '',
        phone: '',
        cellphone: '',
        position: '',
        identification: '',
        priority: -1,
        contactType: -1,
        customer: {
            id: -1,
            customerType: -1,
            status: -1,
            rif: '',
            name: '',
            category: {
                id: -1,
                status: -1,
                name: '',
            },
        },
    },
    role: {
        id: -1,
        name: '',
        description: '',
        rolePrivileges: [],
    },
    customerOptions: [],
};
